import React from 'react';
import { BuggyLanding } from './pages/BuggyLanding';
export function App() {
  return <BuggyLanding data-id="element-0" />;
}